import * as React from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import styled from 'styled-components'

const Wrapper = styled.div`
  z-index: 1000;
`

interface PopoverProps {
  content: any
  index: number
  trigger?: 'hover' | 'click'
  className?: string
  placement?: 'right' | 'left' | 'top' | 'bottom'
  style?: any
  label?: string
}

export const PopoverText: React.FC<PopoverProps> = (props) => {
  return (
    <Wrapper>
      <OverlayTrigger
        trigger={[props?.trigger ?? 'hover', props?.trigger ?? 'hover']}
        key={props.index}
        placement={props.placement}
        overlay={
          <Popover id={`popover-positioned-${props.index}`}>
            <Popover.Body>
              {props?.content === '-' ? (
                ''
              ) : (
                <div dangerouslySetInnerHTML={{__html: props.content}}></div>
              )}
            </Popover.Body>
          </Popover>
        }
      >
        <p className={props.className} style={props.style ? {
            opacity: `${props.content === '-' ? '0' : '100'}`,
            ... props.style
          } : {
            opacity: `${props.content === '-' ? '0' : '100'}`
          }}>
          {' '}
          {props.label === 'Order submission' ? 'A' : props.label === 'SIP' ? 'SIP' : ''}
          <div dangerouslySetInnerHTML={{__html: props.content}}></div>
        </p>
      </OverlayTrigger>
    </Wrapper>
  )
}

export default React.memo(PopoverText)

PopoverText.defaultProps = {
  trigger: 'hover',
  placement: 'right',
  label: '',
}
